import Ajv from 'ajv';
import * as Schema from './schema';

const options = {
    allErrors: true,
};
const validateList = {};
const dataMsg = {};
const IEVer = +(navigator.userAgent.match(/MSIE (\d+)/) && RegExp.$1);

if (IEVer !== 7 && IEVer !== 8) {
    for (const [key, value] of Object.entries(Schema)) {
        const ajv = new Ajv(options);
        const validate = ajv.compile(value);

        validateList[key] = validate;
        dataMsg[key] = value.title;
    }
}

/**
 * ajv schema 校验，校验失败置为 null
 * @param {object} data 前端数据
 * @param {string} schemaKey 数据对应的 schema 对象
 * @param {string} requestUrl 接口请求路径
 */
const schemaCheck = (data, schemaKey, requestUrl) => {
    if (data === null) return data;

    const validate = validateList[schemaKey];

    if (!validate) return data;

    const valid = validate(data);

    if (!valid) {
        console.error(`${dataMsg[schemaKey]} 接口路径：`, requestUrl);
        console.error(`${dataMsg[schemaKey]} 接口有误：`, validate.errors);

        if (window && window.BJ_REPORT)
            window.BJ_REPORT.report(
                new Error(
                    `${requestUrl} schema validate failed: ${JSON.stringify(validate.errors)}, data: ${JSON.stringify(
                        data,
                    )}`,
                ),
                false,
                'api',
            );

        const dataPath = validate.errors[0].dataPath.split('.');

        if (dataPath.length === 0) {
            data = null;
        } else {
            window.data = data;
            new Function(`window.data${validate.errors[0].dataPath} = null`)();
        }
    }

    return data;
};

export { schemaCheck };
